import { render, staticRenderFns } from "./VerifyRegistration.vue?vue&type=template&id=4e44373e&"
import script from "./VerifyRegistration.vue?vue&type=script&lang=js&"
export * from "./VerifyRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports